import { render, staticRenderFns } from "./PlayfieldWorkingHours.vue?vue&type=template&id=1b8f4fee&scoped=true&"
import script from "./PlayfieldWorkingHours.vue?vue&type=script&lang=js&"
export * from "./PlayfieldWorkingHours.vue?vue&type=script&lang=js&"
import style0 from "./PlayfieldWorkingHours.vue?vue&type=style&index=0&id=1b8f4fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f4fee",
  null
  
)

export default component.exports